import clsx from "clsx";
import { ColumnDropWrapper } from "designSystem/dnd/index";
import { Box, FlexColumn, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { attributesSelectionGroupDropTypes } from "../data/dnd/data-management-tab-components";
import AttributeSelections from "./AttributesSelections";
import attributesSelectionsCss from "./CustomViewAttributes.module.css";
import { useCustomViewAttributesStore } from "./CustomViewAttributesStore";


const FlexColumnDropWrapper: FunctionComponent = observer(() => {
	const {
		attributeDndStore,
		dropItem,
		isRootSelectionBoxGrayedOut,
		removeMultiSelectedAttributes,
		showRemoveMultipleAttributes,
	} = useCustomViewAttributesStore();
	const { multiSelectItemArray } = attributeDndStore;

	return (
		<FlexColumn
			className={isRootSelectionBoxGrayedOut && attributesSelectionsCss.greyBackground}
			data-csi-automation="SelectedAttributes"
			width="50%"
		>
			<FlexColumn justifyContent="space-between">
				<ColumnDropWrapper
					disableDropZoneOutline={isRootSelectionBoxGrayedOut}
					dropTypes={attributesSelectionGroupDropTypes}
					isRootDropWrapper
					minHeight={0}
					onDrop={dropItem}
					overflow="hidden auto"
					pb={2}
					px={6}
				>
					<Box className={attributesSelectionsCss.selectionsHeader}>
						<Text
							lineHeight={18}
							res="CustomViewSelectedAttributes"
							semiBold
						/>
					</Box>
					<FlexColumn flexGrow={0}>
						<AttributeSelections />
					</FlexColumn>
				</ColumnDropWrapper>
				{showRemoveMultipleAttributes && (
					<FlexColumn flexGrow={0}>
						<Box
							className={clsx(
								attributesSelectionsCss.multipleAttributesButton,
								attributesSelectionsCss.removeMultipleAttributesText,
							)}
							onClick={removeMultiSelectedAttributes}
						>
							<Text
								res="CustomViewAttributesRemoveSelections"
								resParams={[multiSelectItemArray.length]}
								semiBold
							/>
						</Box>
					</FlexColumn>
				)}
			</FlexColumn>
		</FlexColumn>
	);
});

export default FlexColumnDropWrapper;